export const deCommon = {
    common: {
        asset: 'Immobilie',
        assets: 'Immobilien',
        allAssets: 'Alle Immobilien',
        assetImageAlt: 'Immobilienbild',
        structure: 'Struktur',
        structures: 'Bauliche Anlagen',
        customer: 'Kunde',
        customers: 'Kunden',
        mandator: 'Auftraggeber',
        mandators: 'Auftraggeber',
        order: 'Auftrag',
        orders: 'Aufträge',
        valuation: 'Bewertung',
        valuations: 'Bewertungen',
        valuationReport: 'Wertgutachten',
        valXml: 'ValXML',
        valueCheck: 'Wertüberprüfung',
        draft: 'Entwurf',
        drafts: 'Entwürfe',
        final: 'Final',
        imported: 'Importiert',
        review: 'Prüfung',
        approved: 'Freigegeben',
        latestDraft: 'Aktuellster Entwurf',
        latestValuation: 'Aktuellste Bewertung',
        latestOrder: 'Aktuellster Auftrag',
        overview: 'Übersicht',
        keyFigures: 'Kennzahlen',
        valuationHistory: 'Bewertungshistorie',
        deviationAnalysis: 'Abweichungsanalyse',
        location: 'Standort',
        prices: 'Preise',
        dcf: 'DCF',
        tenantList: 'Mieterliste',
        marketData: 'Marktdaten',
        report: 'Gutachten',
        reportTypes: {
            shortReport: {
                title: 'Markt- & Beleihungswert',
                description: 'gem. § 16 PfandBG',
            },
            extendedReport: {
                title: 'Verkehrswert',
                description: 'gem. § 194 BauGB',
            },
            revaluationReport: {
                title: 'Folgebewertung',
                description: 'gem. § 194 BauGB',
            },
            benchmarkReport: {
                title: 'Wertindikation',
            },
        },
        allReports: 'Alle Gutachten',
        allValXmls: 'Alle ValXMLs',
        unknown: 'Unbekannt',
        unlimited: 'Unbefristet',
        noDate: 'Kein Datum',
        orderDate: 'Beauftragungsdatum',
        valuationDate: 'Wertermittlungsstichtag',
        marketValue: 'Marktwert',
        landValue: 'Bodenwert',
        grossRentalIncome: 'Rohertrag',
        contractRent: 'Vertragsmiete',
        task: 'Aufgabe',
        tasks: 'Aufgaben',
        document: 'Dokument',
        documents: 'Dokumente',
        message: 'Nachricht',
        messages: 'Nachrichten',
        thread: 'Unterhaltung',
        threads: 'Unterhaltungen',
        appraiser: 'Gutachter/in',
        appraisers: 'Gutachter/innen',
        image: 'Bild',
        images: 'Bilder',
        portfolio: 'Portfolio',
        portfolios: 'Portfolios',
        notification: 'Benachrichtigung',
        profile: 'Profil',
        logout: 'Abmelden',
        tools: 'Tools',
        analysis: 'Analyse',
        plausibility: 'Plausibilisierung',
        leadingMethod: 'Führendes Verfahren',
        leadingMethods: 'Führende Verfahren',
        usedMethod: 'Verwendetes Verfahren',
        usedMethods: 'Verwendete Verfahren',
        valueTrend: 'Wertentwicklung',
        rentalIncome: 'Vertragsmiete',
        grossCapitalValue: 'Bruttokapitalwert',
        netCapitalValue: 'Nettokapitalwert',
        netYield: 'Nettorendite',
        ancillaryAcquisitionCosts: 'Erwerbsnebenkosten',
        managementCosts: 'Bewirtschaftungskosten',
        marketRent: 'Marktmiete',
        absolute: 'Absolut',
        relative: 'Relativ',
        rent: 'Miete',
        usageType: 'Nutzungsart',
        subUsageType: 'Unternutzungsart',
        date: 'Datum',
        year: 'Jahr',
        years: 'Jahre',
        index: 'Index',
        count: 'Anzahl',
        share: 'Anteil',
        remaining: 'Restliche',
        units: 'Einheiten',
        parkingSpaces: 'Stellplätze',
        vacancyRate: 'Leerstandsquote',
        actualConstructionYear: 'Tatsächliches Baujahr',
        economicConstructionYear: 'Wirtschaftliches Baujahr',
        valuationYear: 'Jahr der Wertermittlung',
        usefulLife: 'Nutzungsdauer',
        totalEconomicLifeSpan: 'Gesamtnutzungsdauer',
        calculatedResidualLifeSpan: 'Kalkulatorische Restnutzungsdauer',
        customResidualLifeSpan: 'Wirtschaftliche Restnutzungsdauer',
        customResidualLifeSpanOverride: 'Wirtschaftliche Restnutzungsdauer (überschrieben)',
        grossInitialYield: 'Bruttoanfangsrendite',
        grossYield: 'Bruttorendite',
        grossYieldVerbose: 'Yield (Bruttorendite)',
        discountRate: 'Liegenschaftszinssatz',
        rentableArea: 'Vermietbare Fläche',
        livingArea: 'Wohnfläche',
        usageArea: 'Nutzfläche',
        grossFloorArea: 'Bruttogrundfläche',
        landArea: 'Grundstücksfläche',
        wault: 'WAULT',
        valuePerSquareMeter: 'Wert pro m²',
        valuePerSquareMeterRentableArea: 'Wert pro m² WNFl.',
        valuePerSquareMeterGfa: 'Wert pro m² BGF.',
        valuePerSquareMeterLand: 'Wert pro m² Boden',
        mortgageLendingValue: 'Beleihungswert',
        marketValueConfirmed: 'MW bestätigt',
        marketValueNotConfirmed: 'MW nicht bestätigt',
        minimum: 'Minimum',
        average: 'Durchschnitt',
        maximum: 'Maximum',
        total: 'Gesamt',
        change: 'Veränderung',
        percentagePoints: 'BP',
        vacancy: 'Leerstand',
        previousValuation: 'Vorgutachten',
        multiplier: 'Vervielfältiger',
        options: 'Optionen',
        other: 'Sonstige',
        energyEfficiencyClass: 'Energieeffizienzklasse',
        heatingType: 'Heizungsart',
        fuelTypes: {
            wood: 'Holz',
            gas: 'Gas',
            oil: 'Öl',
            environmental_soil: 'Umweltw. (Boden)',
            environmental_air: 'Umweltw. (Außenluft)',
            environmental_solar: 'Umweltw. (Solarthermie)',
            electric_power: 'Strom',
            erdgas: 'Erdgas',
            fluessiggas: 'Flüssiggas',
            heizoel_el: 'Heizöl',
            strom: 'Strom',
            nah_fernwaerme: 'Nah-/Fernwärme',
            holzpellets: 'Holzpellets',
            holzhackschnitzel: 'Holzhackschnitzel',
            stueckholz: 'Stückholz',
            waermepumpe: 'Wärmepumpe',
            solarthermie: 'Solarthermie',
            geothermie: 'Geothermie',
            umweltwaerme: 'Umweltwärme',
            hybrid_system: 'Hybrid',
            biogas_biomethan: 'Biogas',
            steinkohle: 'Steinkohle',
            braunkohle: 'Braunkohle',
        },
        primaryPowerConsumption: 'Primärenergieverbrauch',
        kilowattHoursPerSquareMeterPerYear: 'kWh/m²a',
        carbonDioxideEquivalent: 'CO₂-Äquivalent',
        unitLabels: {
            primaryPowerConsumption: 'kWh/(m²a)',
            carbonDioxideEquivalent: 'kg',
        },
        aiDataPrivacyInfo: {
            tooltip:
                'Ihre Daten werden innerhalb der EU verarbeitet und nicht zum Training von KI-Modellen verwendet. Klicken Sie für weitere Informationen.',
            label: 'Datenschutzkonform',
            modalTitle: 'Datenschutz',
            closeButtonLabel: 'Schließen',
            items: {
                confidentialData: 'Wir verarbeiten Ihre Daten vertraulich und geben Sie nicht an Dritte weiter.',
                storageDuration:
                    'Hochgeladene Dateien werden vorübergehend für die KI-Verarbeitung gespeichert und innerhalb eines Tages gelöscht.',
                euProcessing: 'einwert nutzt ausschließlich europäische Server. Ihre Daten verlassen nie die EU.',
                noModelTraining: 'Ihre Daten werden nicht zum Training von KI-Modellen verwendet.',
                supportPrefix: 'Schreiben Sie uns bei Fragen gerne an',
                supportLinkLabel: 'support@einwert.com',
            },
        },
        notEnoughDataAvailableYet: 'Es stehen noch nicht genügend Daten zur Verfügung',
        marketValueResults: 'Marktwertergebnisse',
        incomeMetrics: 'Ertragskennzahlen',
        residualUsefulLife: 'Restnutzungsdauer',
        sensitivityMatrix: 'Sensitivitätsmatrix',
        valuationKeyFigures: 'Bewertungskennzahlen',
        valXmlDownloadModal: {
            single: {
                title: 'ValXML generieren',
                headline: 'ValXML aus Gutachtendaten generieren',
                paragraphOne: 'ValXML wird aus den vorliegenden Gutachtendaten generiert.',
                notEqual:
                    'Es handelt sich nicht um die ValXML, die ggf. von dem Gutachter/der Gutachterin zusätzlich zum Gutachten übermittelt wurde.',
            },
            multiple: {
                title: 'ValXMLs generieren',
                headline: 'ValXMLs aus Gutachtendaten generieren',
                paragraphOne: 'ValXMLs werden aus den vorliegenden Gutachtendaten generiert.',
                notEqual:
                    'Es handelt sich nicht um die ValXMLs, die ggf. von dem Gutachter/der Gutachterin zusätzlich zu den Gutachten übermittelt wurden.',
            },
            download: 'Herunterladen',
            cancel: 'Abbrechen',
            notAllConvertible:
                'Nicht alle Gutachten können in eine ValXML konvertiert werden, da nicht alle erforderlichen Daten vorliegen.',
            draftWarning:
                'Diese ValXML wird aus einem Entwurf generiert. Die enthaltenen Werte sind noch nicht finalisiert und können vom finalen Gutachten abweichen.',
        },
        orderStatuses: {
            open: {
                label: 'Auftrag eingegangen',
                longLabel: 'Ihr Auftrag wird in Kürze bearbeitet',
            },
            accepted: {
                label: 'Angenommen',
                longLabel: 'Der Auftrag wurde angenommen',
            },
            in_communication_with_owner: {
                label: 'In Kommunikation mit Eigentümer',
                longLabel: 'Wir sind in Kommunikation mit dem Eigentümer des Objekts.',
            },
            inspection_scheduled: {
                label: 'Besichtigung vereinbart',
                longLabel: 'Ein Termin für die Besichtigung wurde vereinbart.',
            },
            in_progress: {
                label: 'Bearbeitung',
                longLabel: 'Gutachten ist in Bearbeitung',
            },
            in_review: {
                label: 'Entwurf prüfen',
                longLabel: 'Neuer Gutachtenentwurf bereit zur Prüfung',
            },
            done: {
                label: 'Abgeschlossen',
                longLabel: 'Auftrag abgeschlossen',
            },
            blocked: {
                label: 'Blockiert',
                longLabel: 'Auftrag blockiert',
            },
            on_hold: {
                label: 'Pausiert',
                longLabel: 'Auftrag pausiert',
            },
            temp_hide_in_portal: {
                label: 'Versteckt',
                longLabel: 'Auftrag wird nur intern angezeigt',
            },
            canceled: {
                label: 'Abgebrochen',
                longLabel: 'Auftrag storniert',
            },
        },
        valuationReasons: {
            transaction: 'Transaktion',
            recurring_valuation: 'Regelmäßiges Wertgutachten',
            division_of_wealth: 'Aufteilung des Vermögens',
            statement_of_assets: 'Vermögensaufstellung',
            financing_purposes: 'Finanzierungszwecke',
            court_proceedings: 'Gerichtsverfahren',
            purchase: 'Ankauf',
            sale: 'Verkauf',
            tax_purposes: 'Steuerliche Zwecke',
            partial_sale: 'Teilverkauf',
            accounting_purposes: 'Bilanzierung',
            intrinsic_value_check: 'Überprüfung der Werthaltigkeit',
            auction: 'Versteigerung',
            lending_purposes: 'Beleihung',
        },
        valuationReasonGroups: {
            recurringValuation: 'Regelmäßiges Wertgutachten',
            legalReasons: 'Rechtlicher Hintergrund',
            accounting: 'Buchführung',
            transactions: 'Handel',
        },
        assetStates: {
            in_planning: 'In Planung',
            under_construction: 'Im Bau',
            existing: 'Bestand',
            time_of_projection: 'Zeitwert der Projektierung',
            after_finalization: 'Nach Fertigstellung',
        },
        usageTypes: {
            residential: 'Wohnen',
            office: 'Büro',
            retail: 'Handel',
            mixed: 'Gemischt genutzte Immobilie',
            garage: 'Parken',
            other: 'Sonstige',
            unknown: 'Unbekannt',
            single_family_house: 'Einfamilienhaus',
            apartment: 'Eigentumswohnung',
            two_family_house: 'Zweifamilienhaus',
            semi_detached_house: 'Doppelhaushälfte',
            townhouse_middle: 'Reihenmittelhaus',
            townhouse_end: 'Reihenendhaus',
            apartment_building: 'Mehrfamilienhaus',
            mixed_use_apartment_building: 'Wohnhaus mit Mischnutzung',
            commercial_structure: 'Wohn- und Geschäftshaus',
            consumer_market: 'Verbrauchermarkt',
            department_store: 'Kauf-/Warenhaus',
            car_dealer: 'Autohaus',
            office_structure: 'Büro',
            single_car_garage: 'Einzelgarage',
            multi_car_garage: 'Mehrfachgarage',
            multi_story_parking_garage: 'Hochgarage',
            underground_parking_garage: 'Tiefgarage',
            commercial_vehicle_garage: 'Nutzfahrzeuggarage',
            infrastructure: 'Infrastruktur',
            logistics: 'Logistik',
            hotel: 'Hotel',
            industrial_structure: 'Industrie',
            nursing: 'Pflege',
            healthcare: 'Gesundheit',
            specialty: 'Spezialimmobilie',
            daycare: 'Kita',
            hostel: 'Boarding house',
            senior_citizen_housing: 'Seniorenwohnen',
            micro_apartment: 'Mikro-Apartment',
            shopping_center: 'Shoppingcenter',
            logistics_hub: 'Logistikzentrum',
            data_center: 'Data center',
        },
        form: {
            salutation: 'Anrede',
            firstName: 'Vorname',
            lastName: 'Nachname',
            jobTitle: 'Rolle',
            phoneNumber: 'Telefonnummer',
            locale: 'Sprache',
            team: 'Team',
            email: 'E-Mail Adresse',
            certification: 'Zertifizierung',
        },
        salutations: {
            none: 'Keine Anrede',
            mr: 'Herr',
            ms: 'Frau',
            mrDr: 'Herr Dr.',
            msDr: 'Frau Dr.',
        },
        userLink: {
            me: 'Ich',
            external: 'Extern',
            unknown: 'Nicht festgelegt',
            unavailable: 'Benutzer nicht verfügbar',
            contact: 'Kontakt',
            editOwnContactTooltip: 'Eigene Kontaktdaten bearbeiten',
            emailCopied: 'Email-Adresse kopiert',
            phoneCopied: 'Telefonnummer kopiert',
            addressCopied: 'Adresse kopiert',
            note: 'Anmerkung',
            externalEmailInfo: 'Dieser Kontakt kollaboriert über E-Mail.',
        },
        confirmation: {
            discardAllUnsavedChanges: 'Alle ungespeicherten Änderungen verwerfen?',
            discard: 'Verwerfen',
            cancel: 'Abbrechen',
        },
        actions: {
            upload: 'Hochladen',
            invite: 'Einladen',
            startImport: 'Import starten',
            apply: 'Übernehmen',
            discard: 'Verwerfen',
            save: 'Speichern',
            cancel: 'Abbrechen',
            remove: 'Entfernen',
            copy: 'Kopieren',
            export: 'Exportieren',
            approve: 'Freigeben',
            close: 'Schließen',
            newOrder: 'Neuer Auftrag',
            viewAsset: 'Zur Immobilie',
            viewOrder: 'Zum Auftrag',
            viewValuation: 'Zur Bewertung',
            viewPlausibility: 'Zur Plausibilisierung',
            expand: 'Ausklappen',
            collapse: 'Einklappen',
        },
        copiedToClipboard: '{{label}} wurde in die Zwischenablage kopiert',
        shortcuts: {
            mac: 'Cmd + S',
            windows: 'Strg + S',
        },
        structureUsageTypes: {
            residential: 'Wohnen',
            office: 'Büro',
            retail: 'Handel',
            mixed: 'Gemischt genutzte Immobilie',
            garage: 'Parken',
            other: 'Sonstige',
        },
        tenantUsageTypes: {
            residential: 'Wohnen',
            commercial: 'Gewerbe',
            gastronomy: 'Gastronomie',
            industry: 'Industrie, Produktion',
            hotel: 'Beherbergung',
            storage: 'Lager',
            underground_parking: 'Tiefgaragenstellplatz',
            leisure: 'Freizeit',
            social: 'Soziale Nutzung',
            archive: 'Keller, Archiv',
            outdoor_parking: 'Außenstellplatz',
            parking: 'Parken',
            retail: 'Handel',
            logistics: 'Logistik',
            office: 'Büro',
            other: 'Andere',
            total: 'Total',
            other_parking: 'Sonstiger Stellplatz',
            open_space: 'Freifläche',
            other_use: 'Sonstige Nutzung',
            garage_parking: 'Garagenstellplatz',
        },
        tenantRentalStatuses: {
            rented: 'Vermietet',
            unrented: 'Leerstand',
            self_used: 'Eigengenutzt',
        },
        tenantBreakdownTable: {
            headers: {
                areaAndUnits: 'Flächen und Einheiten',
                vacancy: 'Leerstand',
                delta: 'Delta',
            },
            empty: 'Keine Einträge vorhanden',
            units: {
                unit_one: 'EH',
                unit_other: 'EH',
                parkingSpace_one: 'Stpl.',
                parkingSpace_other: 'Stpl.',
            },
            monetaryUnits: {
                perYear: '/Jahr',
                perSquareMeterPerMonth: '/m² p.M.',
                perUnitPerMonth: '/EH p.M.',
                perParkingSpacePerMonth: '/Stpl. p.M.',
            },
        },
        deviationAnalysisWidget: {
            headers: {
                current: 'Aktuell',
                change: 'Veränderung',
                previousValuation: 'Vorbewertung',
                previousValuationWithYear: 'Vorbewertung ({{year}})',
            },
            sections: {
                marketValueResults: 'Marktwertergebnisse',
                keyEarningsFigures: 'Ertragskennzahlen',
                costs: 'Kosten',
                yieldFigures: 'Rendite',
                valuationRelevantAreas: 'Flächen',
                valuationStructureLifeSpans: 'Restnutzungsdauer',
            },
            units: {
                year: 'Jahr',
                years: 'Jahre',
            },
            selectOptions: {
                lockedDraftTitle: 'Dieser Entwurf',
                lockedValuationTitle: 'Dieses Gutachten',
                draftStatus: 'Entwurf',
                finalStatus: 'Final',
            },
        },
        valuationMethods: {
            land_value: 'Bodenwert',
            income: 'Ertragswert',
            investment_method: 'Investmentmethode',
            comparison: 'Vergleichswert',
            cost: 'Sachwert',
            discounted_cashflow: 'Discounted Cashflow',
            custom: 'Unbekannt',
            leasehold: 'Erbbaurecht',
        },
    },
    plausibility: {
        approveDraft: 'Entwurf freigeben',
        approvalImageAlt: 'freigeben',
        shareAnnotations: 'Anmerkungen teilen',
        makeAnnotationsVisible: 'Alle Anmerkungen zu diesem Entwurf für den Gutachter/die Gutachterin sichtbar machen',
        draftApproved: 'Entwurf freigegeben',
        approvedBy: 'Freigegeben von',
        noAnnotations: 'Keine Anmerkungen vorhanden',
    },
    marketData: {
        ratings: {
            noRating: 'Keine Bewertung',
            veryGood: 'Sehr gut',
            good: 'Gut',
            average: 'Durchschnittlich',
            mediocre: 'Mäßig',
            bad: 'Schlecht',
            excellent: 'Exzellent',
            aboveAverage: 'Überdurchschnittlich',
            slightlyAboveAverage: 'Leicht überdurchschnittlich',
            belowAverage: 'Unterdurchschnittlich',
            slightlyBelowAverage: 'Leicht unterdurchschnittlich',
            catastrophic: 'Katastrophal',
            veryAboveAverage: 'Stark überdurchschnittlich',
            veryBelowAverage: 'Stark unterdurchschnittlich',
            unableToRate: 'Datenlage erlaubt keine Einordnung',
        },
    },
    export: {
        sectionTitle: 'Export',
        downloadExcelButtonLabel: 'Excel herunterladen',
        valxmlUnavailableTooltip: 'Gutachten ist nicht mit dem ValXML Standard kompatibel oder beinhaltet nicht alle erforderlichen Daten.',
        missingData: {
            featureLabel: 'Vollständigkeitsprüfung',
            fileNamePrefix: 'Vollständigkeitsprüfung-Gutachten',
            modalPrimaryActionLabel: 'Exportieren',
            modalDescription:
                'Hier können Sie die Vollständigkeitsprüfung als Excel-Datei exportieren. Die einzelnen Immobilien sind im Excel jeweils in einzelnen Worksheets strukturiert.',
            modalDownloadInfo:
                'Das Erstellen der Vollständigkeitsprüfung kann einige Minuten dauern. Die Export-Datei wird automatisch heruntergeladen sobald sie fertiggestellt wurde.',
            sectionTitleStructures: 'Bauliche Anlagen',
            sectionTitleValuations: 'Gutachten',
            emptyStateNoAsset: 'Keine Immobilie',
            emptyStateNoStructures: 'Keine Bauliche Anlagen',
            emptyStateNoValuations: 'Keine Gutachten',
            legendTitle: 'Legende',
            legendMeaningAvailable: 'Vorhanden',
            legendMeaningMissing: 'Fehlt',
            legendMeaningMissingOptional: 'Fehlt (aber optional)',
            assetColumnCustomerAssetReference: 'Kundenreferenz',
            assetColumnStreet: 'Straße',
            assetColumnHouseNumber: 'Hausnummer',
            assetColumnZipCode: 'Postleitzahl',
            assetColumnCity: 'Stadt',
            assetColumnRegion: 'Region',
            assetColumnCountry: 'Land',
            assetColumnCoordinates: 'Koordinaten',
            assetColumnTitleImage: 'Titelbild',
            structureColumnTitle: 'Bezeichnung',
            structureColumnUsageType: 'Nutzungsart',
            structureColumnConstructionYear: 'Baujahr',
            structureColumnEnergyEfficiencyClass: 'Energieklasse',
            structureColumnPrimaryPowerConsumption: 'Primärenergieverbrauch',
            structureColumnHeatingEnergySource: 'Heizungsart',
            structureColumnHotWaterEnergySource: 'Warmwasserart',
            structureColumnUsageArea: 'Nettogrundfl./Gebäudenutzfl.',
            valuationColumnTitle: 'Gutachten Titel',
            valuationColumnValuationDate: 'Wertermittlungsstichtag',
            valuationColumnAppraiser: 'Gutachter/in',
            valuationColumnAppraisingEntityName: 'Gutachterbüro',
            valuationColumnPdf: 'PDF',
            valuationColumnMarketData: 'Marktdaten',
            valuationColumnQualityAssessmentDate: 'Qualitätsstichtag',
            valuationColumnReportDate: 'Fertigstellungsdatum',
            valuationColumnInspectionDate: 'Besichtigungsdatum',
            valuationColumnInspector: 'Besichtiger',
            valuationColumnSensitivityMatrix: 'Sensitivitätsmatrix',
            valuationColumnTransactionCosts: 'Transaktionskosten',
            valuationColumnLandArea: 'Grundstücksfläche',
            valuationColumnGrossFloorArea: 'Bruttogrundfläche',
            valuationColumnUsageArea: 'Nutzfläche',
            valuationColumnLivingArea: 'Wohnfläche',
            valuationColumnLandValue: 'Bodenwert',
            valuationColumnIncomeMarketValue: 'Ertragswert',
            valuationColumnCostMarketValue: 'Sachwert',
            valuationColumnComparisonMarketValue: 'Vergleichswert',
            valuationColumnDiscountedCashflow: 'DCF',
            valuationColumnGrossYieldMultiplier: 'Rohertragsmultiplikator',
            valuationColumnNetYieldMultiplier: 'Reinertragsmultiplikator',
            valuationColumnTenantIncomeBreakdown: 'Erträge (Einzeln)',
            valuationColumnYearlyGrossRentalIncome: 'Jahresrohertrag',
            valuationColumnYearlyNetRentalIncome: 'Jahresreinertrag',
            valuationColumnMaintenanceCosts: 'Instandhaltungskosten',
            valuationColumnAdministrativeCosts: 'Verwaltungskosten',
            valuationColumnOperatingCosts: 'Betriebskosten',
            valuationColumnLossOfRentRiskCosts: 'Mietausfallwagnis',
            valuationColumnManagementCosts: 'Bewirtschaftungskosten',
        },
        allValues: {
            downloadTooltip: 'Bewertungskennzahlen herunterladen',
            fileNamePrefix: 'Bewertungskennzahlen',
            worksheetName: 'Bewertungskennzahlen',
            values: {
                waultUnlimited: 'Unbefristet',
            },
            rows: {
                valuationDate: 'Wertermittlungsstichtag',
                discountedCashflowShort: 'DCF',
                transactionCosts: 'Transaktionskosten',
                marketValueIncludingTransactionCosts: 'Marktwert inklusive',
                mortgageLendingValue: 'Beleihungswert',
                mortgageLendingValueWithMethod: 'Beleihungswert {{method}}',
                grossRentalIncome: 'Rohertrag',
                managementCosts: 'Bewirtschaftungskosten',
                netRentalIncome: 'Reinertrag',
                grossYieldMultiplier: 'Rohertragsmultiplikator',
                netYieldMultiplier: 'Reinertragsmultiplikator',
                grossYieldVerbose: 'Yield (Bruttorendite)',
                discountRate: 'Liegenschaftszinssatz',
                grossFloorArea: 'Bruttogrundfläche',
                landArea: 'Fläche',
                residualUsefulLifeWithStructure: 'Restnutzungsdauer ({{structureTitle}})',
                reportLink: 'Link zum Gutachten',
            },
        },
        deviationAnalysis: {
            deviationAnalysisTitle: 'Abweichungsanalyse',
            deviationAnalysisActionButtonLabel: 'Exportieren',
            deviationAnalysisDownloadTooltip: 'Abweichungsanalyse herunterladen',
            deviationAnalysisFileNamePrefix: 'Abweichungsanalyse',
            deviationAnalysisWorksheetName: 'Abweichungsanalyse',
            deviationAnalysisAssetLabel: 'Immobilie',
            deviationAnalysisValueColumnLabel: 'Wert',
            deviationAnalysisChangeColumnLabel: 'Veränderung',
            deviationAnalysisChangePercentageColumnLabel: 'Veränderung %',
            deviationAnalysisRemainingUsefulLifePrefix: 'Restnutzungsdauer',
            deviationAnalysisRowMortgageLendingValue: 'Beleihungswert',
            deviationAnalysisRowTransactionCosts: 'Transaktionskosten',
            deviationAnalysisRowTotalSpecialPropertyFeatures: 'BOG',
            deviationAnalysisRowGrossRentalIncome: 'Rohertrag (Marktmiete)',
            deviationAnalysisRowContractualRentalIncome: 'Jahresmiete (Vertragsmiete)',
            deviationAnalysisRowManagementCosts: 'Bewirtschaftungskosten',
            deviationAnalysisRowMaintenanceCost: 'Instandhaltungskosten',
            deviationAnalysisRowAdministrativeCost: 'Verwaltungskosten',
            deviationAnalysisRowOperatingCost: 'Nicht umlagefähige Betriebskosten',
            deviationAnalysisRowLossOfRentRiskCost: 'Mietausfallwagnis',
            deviationAnalysisRowNetRentalIncome: 'Reinertrag',
            deviationAnalysisRowNetIncomeConstruction: 'Reinertrag der baulichen Anlage',
            deviationAnalysisRowValueConstruction: 'Ertragswert der baulichen Anlage',
            deviationAnalysisRowGrossYieldMultiplier: 'Rohertragsmultiplikator',
            deviationAnalysisRowNetYieldMultiplier: 'Reinertragsmultiplikator',
            deviationAnalysisRowGrossYield: 'Yield (Bruttorendite)',
            deviationAnalysisRowGrossFloorArea: 'Bruttogrundfläche',
        },
    },
}
